import { render, staticRenderFns } from "./WebstarsIndex.vue?vue&type=template&id=f5038004&scoped=true&"
import script from "./WebstarsIndex.vue?vue&type=script&lang=js&"
export * from "./WebstarsIndex.vue?vue&type=script&lang=js&"
import style0 from "./WebstarsIndex.vue?vue&type=style&index=0&id=f5038004&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5038004",
  null
  
)

component.options.__file = "WebstarsIndex.vue"
export default component.exports